const updates = [
  { time: '10分钟前', tag: '爆料', title: '某顶流男星深夜密会神秘女子，酒店同框照独家曝光', summary: '据知情人士透露，该男星近期行程与公开信息存在多处矛盾，疑似刻意隐瞒行程。本网已获取独家现场影像资料。', hot: true },
  { time: '28分钟前', tag: '翻车', title: '知名网红直播间言论翻车，不当措辞引发全网联合抵制', summary: '该网红在直播中发表争议性言论后，多个品牌方连夜宣布解除合作关系，社交账号掉粉超百万。', hot: true },
  { time: '1小时前', tag: '实锤', title: '某女团成员前男友曝光三年私密聊天记录，信息量巨大', summary: '聊天记录涉及多位圈内人士的私下言论，目前已有经纪公司发律师函要求删除相关内容。', hot: false },
  { time: '2小时前', tag: '内幕', title: '综艺节目录制现场激烈争执画面流出，节目组紧急公关', summary: '据现场工作人员爆料，争执起因是节目组临时修改规则，导致某嘉宾当场发飙离场。', hot: true },
  { time: '3小时前', tag: '调查', title: '某说唱歌手被曝税务问题，工作室发文称正在配合相关部门调查', summary: '该事件已引发连锁反应，多位与其有商业合作的品牌方表示将密切关注调查进展。', hot: false },
  { time: '5小时前', tag: '泄密', title: '影视剧组内部人员泄露未播关键片段，制作方已启动追责程序', summary: '泄露片段在网络疯传后，该剧集预约量反而暴涨，有网友质疑是否为刻意营销手段。', hot: false },
  { time: '7小时前', tag: '深扒', title: '某知名导演新片选角内幕流出，潜规则疑云再度笼罩影视圈', summary: '多位新人演员的试镜视频被曝光，选角标准引发行业内外广泛讨论与质疑。', hot: true },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">实时追踪</span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">每日快讯</h2>
          <p className="text-foreground-600 text-sm mt-2">娱乐圈吃瓜第一线，实时更新最新爆料</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-200"></div>
          <div className="space-y-0">
            {updates.map((item, i) => (
              <div key={i} className="relative pl-10 md:pl-14 pb-8 last:pb-0">
                <div className={`absolute left-2.5 md:left-4.5 top-1 w-3 h-3 rounded-full border-2 border-background-50 ${
                  item.hot ? 'bg-primary-500' : 'bg-secondary-400'
                }`}></div>
                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-xs text-foreground-400">{item.time}</span>
                    <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                      item.hot ? 'bg-primary-100 text-primary-700' : 'bg-secondary-100 text-secondary-700'
                    }`}>{item.tag}</span>
                    {item.hot && (
                      <span className="flex items-center gap-0.5 text-xs text-primary-600 font-medium">
                        <i className="ri-fire-line text-xs"></i>热
                      </span>
                    )}
                  </div>
                  <h3 className="text-base md:text-lg font-bold text-foreground-900 leading-snug">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}